module.exports = __webpack_public_path__ + "img/shangxia.ed372689.png";